// BackgroundColorChanger.js
import React from 'react';
import './BackgroundColorChanger.css';

const BackgroundColorChanger = ({ color = '#FFFFFF', onChange, disabled = false }) => {
    return (
        <div className={`modern-background-changer ${disabled ? 'disabled' : ''}`}>
            <div className="modern-bg-item">
                <div className="modern-bg-label">
                    Background Color
                </div>
                <div className="modern-bg-picker-container">
                    <div 
                        className="modern-bg-preview" 
                        style={{ backgroundColor: color || '#FFFFFF' }}
                    >
                        <input
                            id="backgroundColorPicker"
                            type="color"
                            value={color || '#FFFFFF'}
                            onChange={(e) => !disabled && onChange?.(e.target.value)}
                            className="modern-bg-input"
                            disabled={disabled}
                            title={disabled ? 'Use Space Settings to change background color' : 'Change background color'}
                        />
                    </div>
                    <div className="modern-bg-code">
                        {color?.toUpperCase() || '#FFFFFF'}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BackgroundColorChanger;
